import React from 'react';
import { TextField, Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

interface HolderInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  label?: string;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
}

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    fontFamily: 'Consolas, Monaco, "Courier New", monospace',
    fontSize: '14px',
    lineHeight: '1.5',
    backgroundColor: '#fff',
    '& fieldset': {
      borderColor: '#ddd',
    },
    '&:hover fieldset': {
      borderColor: '#999',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#1976d2',
    },
  },
  '& .MuiInputBase-input': {
    color: '#333',
    '&::placeholder': {
      color: '#999',
      opacity: 1,
    },
  },
}));

const HolderInput: React.FC<HolderInputProps> = ({
  value,
  onChange,
  placeholder = 'Enter template placeholders (e.g., ${variable})...',
  label = 'Template Holder',
  error = false,
  helperText,
  disabled = false,
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="subtitle2" sx={{ mb: 1, color: '#666', fontWeight: 500 }}>
        {label}
      </Typography>
      <StyledTextField
        multiline
        rows={6}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        error={error}
        helperText={helperText}
        disabled={disabled}
        fullWidth
        variant="outlined"
        size="small"
        sx={{
          '& .MuiOutlinedInput-root': {
            minHeight: '150px',
            '& textarea': {
              padding: '16px',
              resize: 'vertical',
            },
          },
        }}
      />
    </Box>
  );
};

export default HolderInput; 